import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=7a1007ac&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=ts"
export * from "./NotificationDropdown.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=7a1007ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1007ac",
  null
  
)

export default component.exports